import { isFeatureEnabled } from 'Optimizely'

const REGISTRATION_STEP_TOTAL = {
  newFlow: 7,
  oldFlow: 6,
} as const

export const REGISTRATION_STEPS = {
  BASIC_INFO: { newFlow: 1, oldFlow: 1 },
  DRIVING_INFO: { newFlow: 2, oldFlow: 2 },
  BACKGROUND: { newFlow: null, oldFlow: 3 },
  DISCLOSURES: { newFlow: 4, oldFlow: null },
  SSN: { newFlow: 5, oldFlow: null },
  BANK_INFO: { newFlow: 6, oldFlow: 4 },
  PHOTO_AND_BIO: { newFlow: 7, oldFlow: 5 },
} as const

export type RegistrationStepKey = keyof typeof REGISTRATION_STEPS

type RegistrationProfile = { id?: number | string; [key: string]: unknown } | null | undefined

export function formatRegistrationStep(stepKey: RegistrationStepKey, profile?: RegistrationProfile) {
  const enabled = isFeatureEnabled('new-compliance-flow', profile)
  const { newFlow, oldFlow } = REGISTRATION_STEPS[stepKey]
  const step = enabled ? newFlow : oldFlow

  if (step == null) {
    return null
  }

  const total = enabled ? REGISTRATION_STEP_TOTAL.newFlow : REGISTRATION_STEP_TOTAL.oldFlow
  return `Step ${step} of ${total}`
}
